import { defineQuery } from "next-sanity";

export const frontpageContentQuery = defineQuery(`
    *[_type == "frontpage" && language == $lang]{
      ...,
      notification_banner_visible,
      carousel_visible,
      article_list_visible,
    }[0]
  `);

export const pageQuery = defineQuery(`
      *[_type == "page" && slug.current == $slug]{
        page_type,
        _id,
        title,
        main_title,
        video,
        "heroVideo": video.asset->url,
        image,
        image_layout,
        description,
        intro,
        articleContent,
        "heroSrc": image.asset->url,
        "seoSrc": seo_image.asset->url,
        includeBanner,
        publishedAt,
        seo_title,
        seo_description,
        seo_keywords,
        enable_product_filtering,
        product_filter_skus,

        "translations": *[_type == "translation.metadata" && references(^._id)].translations[].value->{
          "slug": slug.current,
          language
        },

        "children": *[_type=="page" && references(^._id)] | order(publishedAt desc){
          _id,
          title,
          slug,
          parent,
          "imgSrc": image.asset->url,
          "seoImgSrc": seo_image.asset->url,
        }
      }[0]
    `);

export const faqQuery = defineQuery(`
      *[_type == "faq" && slug.current == $slug]{
        _id,
        title,
        intro,
        slug,
        faqGroups,
        "children": *[_type=="faq" && references(^._id)] | order(publishedAt desc){
          _id,
          title,
          description,
          slug,
          parent,
          "imgSrc": image.asset->url,
          "seoImgSrc": seo_image.asset->url,
        }
      }[0]
    `);

export const pageSlugsQuery = defineQuery(`
  *[_type == "page" && defined(slug.current)]{
    "slug": slug.current
  }`);

export const siteSettingsQuery = defineQuery(`
    *[_type == "siteSettings"][0]
  `);
